import { z } from 'zod';

export const callerConfirmationSchema = z.object({
    nameConfirmed: z.boolean(),
    addressConfirmed: z.boolean(),
    postcodeConfirmed: z.boolean(),
});

export type CallerConfirmationFormValues = z.infer<typeof callerConfirmationSchema>;
